import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchFeedbacks = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/feedbacks/admin`);
    if (!response.ok) throw new Error("Не вдалося завантажити фідбеки");
    return response.json();
};

export const updateFeedback = async (id, data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/feedbacks/admin/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || "Не вдалося оновити фідбек");
    }
};

export async function fetchUnreadAdminFeedbacks() {
    const response = await apiFetch(`${API_BASE_ADMIN}/feedbacks/admin/unread`);
    return response.json();
}